export default "__VITE_ASSET__p7pc6tU1__"